import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TokenResponse, User } from './interface';
import { map } from 'rxjs/operators';
import { UserProfileResponseInterface } from '@shared/interfaces/user/user.profile';

@Injectable({
  providedIn: 'root',
})
export class UserApiService {
  constructor(protected http: HttpClient) {
  }

  login(username: string, password: string) {
    return this.http.post<{ data: TokenResponse }>('/api/v1/user/login', {
      username,
      password,
    });
  }

  logout() {
    return this.http.patch('/api/v1/user/logout', {});
  }

  basicUserInfo() {
    return this.http.get<{ data: User }>('/api/v1/user/basic-info')
      .pipe(
        map(response => {
          const user = response.data;

          if (user.avatar === undefined) {
            user.avatar = 'https://eu.ui-avatars.com/api/?name=' + user.username;
          }

          return user;
        })
      );
  }

  menu() {
    // return this.http.get('/me/menu');
    return this.http.get('assets/data/menu.json?_t=' + Date.now());
  }

  updatePassword(userId: string, newPassword: string) {
    return this.http.patch<{ data: UserProfileResponseInterface }>('/api/v1/user/password/' + userId, {
      password: newPassword
    }).pipe(
      map(response => {
        return response.data;
      })
    );
  }
}
